var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('el-button',{staticStyle:{"padding":"0","margin":"20px"},attrs:{"type":"text","icon":"el-icon-back"},on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._v(" 返回 ")])],1)],1),_c('el-form',{ref:"ruleForm",staticClass:"demo-ruleForm",attrs:{"model":_vm.info,"label-width":"100px"}},[_c('banner-target',{ref:"bannerTarget",attrs:{"target":_vm.info.target,"address":_vm.info.address,"target_msg":_vm.info.target_msg,"target_id":_vm.info.target_id,"source_type":_vm.source_type},on:{"target1":_vm.target1}}),(
      [
        'vip_level_detail',
        'target_h5',
        'group_course_list',
        'group_course_p_list',
        'group_product_list',
        'flash_sale_course',
        'flash_sale_course_p',
        'flash_sale_product',
        'salon_list'
      ].indexOf(_vm.theTarget) >= 0
    )?_c('el-form-item',{attrs:{"label":"标题","prop":"title"}},[_c('el-input',{staticStyle:{"width":"33%"},attrs:{"maxlength":"30","show-word-limit":""},model:{value:(_vm.info.title),callback:function ($$v) {_vm.$set(_vm.info, "title", $$v)},expression:"info.title"}})],1):_vm._e(),(
      [
        'vip_level_detail',
        'target_h5',
        'group_course_list',
        'group_course_p_list',
        'group_product_list',
        'flash_sale_course',
        'flash_sale_course_p',
        'flash_sale_product',
        'salon_list'
      ].indexOf(_vm.theTarget) >= 0
    )?_c('el-form-item',{attrs:{"label":"图片"}},[_c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":_vm.ossAction,"show-file-list":false,"http-request":_vm.uploadOSSRequest,"before-upload":_vm.beforeImageUpload}},[(_vm.info.resource)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.info.resource}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"}),_c('div',{staticClass:"el-upload__tip",attrs:{"slot":"tip"},slot:"tip"},[_vm._v(" 只能上传jpg/png文件，尺寸275x320px，大小不超过100K ")])])],1):_vm._e(),_c('el-form-item',[_c('el-button',{attrs:{"size":"small","type":"primary","loading":_vm.updateLoading},on:{"click":function($event){return _vm.createUpdate()}}},[_vm._v("确 定")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }